import { render } from "./PrincipalsTable.vue?vue&type=template&id=585dcb5f"
import script from "./PrincipalsTable.vue?vue&type=script&lang=ts"
export * from "./PrincipalsTable.vue?vue&type=script&lang=ts"
script.render = render

export default script